
// eslint-disable-next-line quotes
import { defineStore } from "pinia"
import services from '@/services'

import { DataNotify } from '@/types/internalChatAxios'

interface RootState {
  items: DataNotify[];
  bearer: string;
}

export const useNotifyStore = defineStore({
  id: 'notify',
  state: (): RootState => ({
    bearer: '',
    items: [],
  }),
  /*
  */
  getters: {
    all: (state) => state.items,
    config: (state) => {
        return {
            headers: {
                Accept: 'application/json',
                'Content-type': 'application/json',
                Authorization: 'Bearer ' + state.bearer
            }
        }
    },
    getById: (state) => (id: number) => state.items.find((el) => el.id === id),
    // getById: (state) => (id: number) => findById(state.items, id)
  },
  /*
  */
  actions: {
    async initialize () {
      const { data, errors } = await services.notify.initialize()
      if (errors) {
        throw new Error('error request initialize notify')
      }
      this.items.push(...data)
      return this.items
    },
    upBearer (bearer : string) {
        this.bearer = bearer
    },
  }
})
